import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import moment from "moment";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import { Box, Button } from "@mui/material";
import { SYLLABUS_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import { ValidationSchema } from "./components/ValidationSchema/ValidationSchema";
import SubmitBtn from "./components/Buttons/SubmitBtn";
import InputField from "./components/Inputs/InputField";
import Course from "./components/selectCollection/Course";
import { FaFilePdf } from "react-icons/fa6";

const SyllabusModal = () => {
  const dispatch = useDispatch();
  const { syllabusModalData: modalData } = useSelector(
    (state) => state.syllabusModal
  );
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfError, setPdfError] = useState("");

  // formik
  const formik = useFormik({
    initialValues: {
      course: modalData.course ? modalData.course : "",
    },
    validationSchema: ValidationSchema,
    validateOnMount: true,
  });

  const setInputValue = useCallback(
    (key, value) =>
      formik.setValues({
        ...formik.values,
        [key]: value,
      }),
    [formik]
  );

  const onPickPdf = (e) => {
    const file = e.target.files?.[0];
    setPdfError("");
    if (!file) {
      setPdfFile(null);
      return;
    }
    if (file.type !== "application/pdf") {
      setPdfError("Yalnız PDF faylı yükləyə bilərsiniz.");
      setPdfFile(null);
      return;
    }

    setPdfFile(file);
  };

  const updateModalState = (keyName, value) => {
    setInputValue(keyName, value);
    dispatch({
      type: SYLLABUS_MODAL_ACTION_TYPE.GET_SYLLABUS_MODAL,
      payload: {
        data: { ...modalData, [keyName]: value },
        openModal: true,
      },
    });
  };
  const closeModal = () => {
    dispatch({
      type: SYLLABUS_MODAL_ACTION_TYPE.GET_SYLLABUS_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  console.log(modalData, "bbbbbbbbbbbbbbbbbbbbbbb");

  return (
    <div className="create-update-modal-con teacher-modal">
      <div className="create-update-modal">
        <div className="create-update-modal-head">
          <h2>{modalData?._id ? "Sillabus yenilə" : "Sillabus yarat"}</h2>
          <CloseBtn onClick={closeModal} />
        </div>

        <Box
          onSubmit={(e) => e.preventDefault()}
          component="form"
          sx={{
            width: 500,
            maxWidth: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="create-update-modal-form">
            <Course
              modalData={modalData}
              updateModalState={updateModalState}
              formik={formik}
            />

            <Button
              variant="contained"
              component="label"
              sx={{ mt: 3, fontSize: "12px" }}
            >
              Fayl əlavə et
              <FaFilePdf style={{ marginLeft: "8px", fontSize: "20px" }} />
              <input
                type="file"
                accept="application/pdf"
                hidden
                onChange={onPickPdf}
              />
            </Button>
            <span>{pdfError}</span>
          </div>
        </Box>

        {modalData?._id ? (
          <SubmitBtn
            formik={formik}
            modalData={modalData}
            funcType="update"
            pdfFile={pdfFile}
          />
        ) : (
          <SubmitBtn
            formik={formik}
            modalData={modalData}
            funcType="create"
            pdfFile={pdfFile}
          />
        )}

        {modalData?._id && (
          <div className="joined-time">
            Qoşuldu: {moment(modalData.createdAt).format("YYYY.MM.DD")}
          </div>
        )}
      </div>
    </div>
  );
};

export default SyllabusModal;
